import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FOZ_67 } from "@/lib/programs/fezSidialiOuarzazate67";

export default function FezSidialiOuarzazate67Page() {
  return <ProgramTemplate program={PROGRAM_FOZ_67} variant="foz" showJourneyChronology />;
}
